import "../icon-svg.less";

const IconCollect = ({ className = "" }: { className?: string }) => (
  <svg
    className={`icon-svg icon-collect ${className}`}
    viewBox="0 0 22 22"
    version="1.1"
    fill="none"
  >
    <g id="icon/&#230;&#148;&#182;&#232;&#151;&#143;1">
      <path
        id="Vector"
        d="M11.8647 2.29366C11.5109 1.58067 10.4929 1.58328 10.1427 2.29809L7.85999 6.95746C7.7205 7.24218 7.44943 7.43966 7.13566 7.48516L1.92218 8.24114C1.13526 8.35525 0.820263 9.32179 1.38885 9.87766L5.17031 13.5746C5.39691 13.7961 5.49958 14.1152 5.4447 14.4273L4.55105 19.5097C4.41249 20.2977 5.24211 20.8994 5.94815 20.523L10.5477 18.071C10.8299 17.9205 11.1686 17.9205 11.4508 18.071L16.0546 20.5248C16.7602 20.9008 17.5893 20.3001 17.4519 19.5125L16.5641 14.4261C16.5097 14.1146 16.6122 13.7964 16.8381 13.5752L20.6152 9.87603C21.1828 9.32018 20.8682 8.35483 20.082 8.24021L14.903 7.48503C14.5912 7.43958 14.3216 7.24406 14.1816 6.96186L11.8647 2.29366Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default IconCollect;
